module.exports = __webpack_public_path__ + "static/media/158.ecb15c3f.jpg";